import { memo, useState, useCallback } from 'react';

import {
  Modal,
  ModalContent,
  ModalActions,
  Pushbutton,
  FieldText
} from '@stratumn/atomic';

import { EventChangeHandler } from 'utils/types';

import useStyles from './editKeyModal.style';

interface Props {
  fieldKey?: string;
  submit: (value: string | null) => void;
  cancel: () => void;
}

export const EditKeyModal = ({ fieldKey, submit, cancel }: Props) => {
  const [key, setKey] = useState(fieldKey);
  const classes = useStyles();
  const handleOnSubmit = useCallback(() => submit(key || null), [key, submit]);
  const handleChange: EventChangeHandler = useCallback(
    e => setKey(e.target.value),
    []
  );

  return (
    <Modal
      title="Edit field key"
      closeButtonLabel="Cancel"
      handleCollapse={cancel}
      hideHeaderBorderBottom
    >
      <ModalContent>
        <FieldText
          dataCy="input-field-key"
          label="field key"
          placeholder={key}
          value={key}
          onValueChange={handleChange}
          hideLabel
        />

        <p className={classes.modalContent}>
          <span>Caution:</span> You are about to update a key. This action will
          have a direct impact on all the admin process inputs related to this
          key.
        </p>
      </ModalContent>
      <ModalActions
        adverseAction={
          <Pushbutton onClick={cancel} dataCy="cancel-button">
            cancel
          </Pushbutton>
        }
      >
        <Pushbutton primary onClick={handleOnSubmit} dataCy="submit-button">
          confirm
        </Pushbutton>
      </ModalActions>
    </Modal>
  );
};

EditKeyModal.defaultProps = {
  fieldKey: ''
};

export default memo(EditKeyModal);
